import React,  { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, Text, View } from "react-native";
import HeaderWithBack from "../../../components/Header/headerWithBack";
import { useCssStyle } from "../../../customHook/getCssStyle";
import CustomCheckBoxWithProps from "../../../components/checkBox/customCheckBox";
import CustomDropDown from "../../../components/customDropdown/customDropdown";
import { CustomTextInput } from "../../../components/customTextInput";
import { sendAnalytics } from "../../../Redux/Actions/analyticsAction";
import { MOBILE_CHECKIN_CATEGORY } from "../../../config/Constant";
import { useDispatch } from "react-redux";
import CustomPressable from "../../../components/customPressable/customPressable";
import { setRenderFlashMessage } from "../../../Redux/Actions/appConfigAction";

const AccompanyingGuestDetailsInput = (props) => {
    const { accompanyGuests, checkinSessionToken, handleGoBack, handleCancel, handleNext, primaryBtnTxt, secondaryBtnTxt } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const [accompanyGuestsList, setAccompanyGuestsList] = useState(accompanyGuests)
    const mandatoryMark = <Text style={{ color: "red" }}>*</Text>;

    useEffect(()=> {
        if(accompanyGuests.length > 0){
            const newAccompanyGuest = accompanyGuests.map(guest => ({...guest, firstName: guest.firstName || guest.name1, lastName: guest.lastName || guest.name2 }));

            setAccompanyGuestsList(newAccompanyGuest);
        }
        
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "COMPANION DETAILS", { "element": "widget", "pageName": "COMPANION DETAILS", "widgetSessionId": checkinSessionToken}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleAccompanyGuest = (index, value, key) => {
        setAccompanyGuestsList(
            accompanyGuestsList.map((guest, i) => {
                if (i === index) {

                    let guestData = { ...guest, [key]: value };
                    if(key == "guestType" && value == "adult"){
                        guestData = {...guestData, age: ""}
                    }
                    return guestData;
                }
                return guest;
            })
        );
    }

    const handleGuestDetailsNext = () => {
        let nextStep = true;
        accompanyGuestsList.forEach((guest) => {
            if (guest.firstName == "" || guest.lastName == "") {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: "Please enter all the mandatory fields to proceed"}));
                nextStep = false;
            }

            if (guest.guestType == "child" && (guest.age == null || guest.age == "")) {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: "Please enter all the mandatory fields to proceed"}));
                nextStep = false;
            }
        })

        if(nextStep){
            handleNext(accompanyGuestsList)
        }
    }

    return <View style={getStyles(['widgetRootContainer', 'accompanyGuestDetailsRootContainer'])} >
        <HeaderWithBack handleCustomBackPress={handleGoBack}/>

        <ScrollView 
            automaticallyAdjustKeyboardInsets={true} 
            contentContainerStyle={getStyles(['widgetmainContainer', 'accompanyGuestDetailsMainContainer'])} 
            showsVerticalScrollIndicator={false}
        >
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'accompanyGuestDetailsHeaderContainer'])}>
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'accompanyGuestDetailsHeaderTitleContainer'])}>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'accompanyGuestDetailsHeaderTitle'])}>
                        {t('check_in.accompany_guest_inputs.heading')}
                    </Text>

                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'accompanyGuestDetailsHeaderSubTitle'])}>
                        {t('check_in.accompany_guest_inputs.sub_heading')}
                    </Text>
                </View>
            </View>

            <View style={getStyles(['widgetmainContainerChildContainer', 'accompanyGuestDetailsMainContainerChildContainer'])}>
                {accompanyGuestsList.map((guest, index) => {
                    return (
                    <View key={guest.profileId} style={getStyles(['accompanyGuestInputGuestMainContainer'])}>
                        <View style={getStyles(['accompanyGuestInputGuestHeadingContainer'])}>
                            <Text style={getStyles(['accompanyGuestInputGuestHeading'])}>{t('check_in.accompany_guest_inputs.guest_heading')}{index+1}</Text>
                        </View>

                        <View style={getStyles(['accompanyGuestInputGuestChildContainer'])}>
                            <View style={getStyles(['textContainer',  'accompanyGuestFirstNameContainer'])}>
                                <Text style={getStyles(['label', 'accompanyGuestTextContainer',])}>{t('check_in.accompany_guest_inputs.first_name')} {mandatoryMark}</Text>
                                <CustomTextInput
                                    value={accompanyGuestsList[index]['firstName']}
                                    onChangeText={(value) => handleAccompanyGuest(index, value, "firstName")}
                                    placeholder={t("check_in.accompany_guest_inputs.first_name_placeholder")}
                                />
                            </View>
                            <View style={getStyles(['textContainer', 'accompanyGuestLastNameContainer'])}>
                                <Text style={getStyles(['label', 'accompanyGuestTextContainer'])}>{t('check_in.accompany_guest_inputs.last_name')} {mandatoryMark}</Text>
                                <CustomTextInput
                                    value={accompanyGuestsList[index]['lastName']}
                                    onChangeText={(value) => handleAccompanyGuest(index, value, "lastName")}
                                    placeholder={t("check_in.accompany_guest_inputs.last_name_placeholder")}
                                />
                            </View>

                            <View style={getStyles(['accompanyGuestCheckboxContainer'])}>
                                <CustomCheckBoxWithProps 
                                    value={accompanyGuestsList[index]['guestType'] === "adult"}
                                    onValueChange={() => handleAccompanyGuest(index, "adult", "guestType")}
                                    checkBoxStyle={getStyles(['accompanyGuestCheckBox'])}
                                />
                                <Text style={getStyles(['accompanyGuestCheckboxText'])}>{t('check_in.accompany_guest_inputs.checkbox_heading_1')}</Text>
                            </View>

                            <View style={getStyles(['accompanyGuestCheckboxInputContainer'])}>
                                <View style={getStyles(['accompanyGuestChildCheckboxContainer'])}>
                                    <CustomCheckBoxWithProps
                                        value={accompanyGuestsList[index]['guestType'] === "child"}
                                        onValueChange={() => handleAccompanyGuest(index, "child", "guestType")}
                                        checkBoxStyle={getStyles(['accompanyGuestCheckBox'])}
                                    />
                                    <Text style={getStyles(['accompanyGuestCheckboxText'])}>{t('check_in.accompany_guest_inputs.checkbox_heading_2')}</Text>
                                </View>

                                {accompanyGuestsList[index]['guestType'] === "child" && <View style={getStyles(['accompanyGuestCheckboxInputTextContainer'])}>
                                    <CustomTextInput
                                        value={accompanyGuestsList[index]['age'] ?? ''}
                                        onChangeText={(value) => handleAccompanyGuest(index, value, "age")}
                                        keyboardType='numeric'
                                        maxLength={2}
                                        style={getStyles(['accompanyGuestCheckboxInputText'])}
                                        placeholder={t("check_in.accompany_guest_inputs.age")}
                                    />
                                </View>}
                            </View>
                        </View>
                    </View>
                )})}
            </View>

        </ScrollView>
        <View id='accompanyGuestUpdateContainer' style={getStyles(['accompanyGuestUpdateContainer'])}>
            <CustomPressable 
                id='primaryBtn' 
                onPress={() => handleGuestDetailsNext()} 
                style={getStyles(['primaryBtn'])}
            >
                <Text id='primaryBtnTxt' style={getStyles(['primaryBtnTxt'])}>
                    {primaryBtnTxt || "Next"}
                </Text>
            </CustomPressable>
        </View>
    </View>

}

export default AccompanyingGuestDetailsInput;